import dayjs, { Dayjs, OpUnitType } from 'dayjs';
export const DAYJS_VISUALIZATION_DATE_FORMAT = 'DD/MM/YYYY';
export const DAYJS_VISUALIZATION_TIME_FORMAT = 'HH:mm';
export const DAYJS_DATA_DATE_FORMAT = 'YYYY-MM-DD';
export const DAYJS_DATA_TIME_FORMAT = 'HH:mm:ss';

export const MONTHS = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december',
];

export const WEEKDAYS = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
];

export const CALENDAR_VIEW_TYPES = {
  DAY: 'timeGridDay',
  MONTH: 'dayGridMonth',
  WEEK: 'timeGridWeek',
};

export const formatMonthYear = (date: Date): string => {
  return date.toLocaleString('en', { month: 'long', year: 'numeric' });
};

export const formatWeekRange = (start: Date, end: Date): string => {
  const startStr = start.toLocaleString('en', {
    month: 'short',
    day: 'numeric',
  });
  const endStr = end.toLocaleString('en', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });

  return `${startStr} - ${endStr}`;
};

export const formatDay = (date: Date): string => {
  return date.toLocaleString('en', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
};

export const getNullableDayjsDifferenceChecker =
  (unit?: OpUnitType) => (a: Dayjs | null, b: Dayjs | null) =>
    a !== null && b !== null ? !a.isSame(b, unit) : a !== b;

export const buildDayjsTimeCompatibleString = (
  time: string /*(HH:mm:ss)*/,
  todayString?: string,
): string =>
  (todayString ?? new Date().toISOString().split('T')[0]) + 'T' + time;

export const getMonthRange = (referenceDate: Date): [string, string] => {
  const date = new Date(referenceDate);

  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear().toString();

  const startDate = `${year}-${month}-01`;

  // To get the last date of the month, we sent the date object month to the next one and the month's day to -1.
  // This sets it effectivelly to the last day of the current month.
  date.setDate(1);
  date.setMonth(date.getMonth() + 1);
  date.setDate(0);

  const endDate = `${year}-${month}-${date.getDate().toString().padStart(2, '0')}`;

  return [startDate, endDate];
};

export const getFirstStartingMonthDate = (referenceDate: Date): Date => {
  const date = new Date(referenceDate);
  /*  If the reference date doesn't match the first day of its month, the thens moves to the first day
  of the next month */
  const setToNextMonth = date.getDate() > 1;
  date.setDate(1);
  date.setMonth(date.getMonth() + (setToNextMonth ? 1 : 0));

  return date;
};

export const formatDateTime = (date: string | null, time: string | null) => {
  const dateObject = dayjs(date);
  if (!dateObject.isValid() && !time) {
    return '';
  }

  return `${dateObject.isValid() ? dateObject.format(DAYJS_VISUALIZATION_DATE_FORMAT) : '-/-/-'} ${time ? time.split(':').slice(0, 2).join(':') : '-:-'}`;
};
